import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getOnlyStateList } from "../../../services/Settings/dropdown"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const StateOnlyList = ({
  control,
  name,
  onSelectChange,
  target,
  placeholder,
  dropView
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [fetchResponse, setFetchResponse] = useState([])

  const loadOptions = async () => {
    const data = await getOnlyStateList()
    setIsLoading(false)
    const response = data?.data?.map(dta => {
      return {
        label: dta?.name && ucfirst(dta.name),
        value: dta.id,
        ...dta,
      }
    })

    setFetchResponse(response)
  }
  useEffect(() => {
    loadOptions()
  }, [])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({
          field: { onChange, ref, value },
          fieldState: { invalid },
        }) => {
          return (
            <Select
              options={fetchResponse}
              // placeholder={placeholder ? placeholder : "Select"}
              placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
              isLoading={isLoading}
              inputRef={ref}
              invalid={invalid}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              value={value}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              //   menuPortalTarget={document.querySelector(
              //     target ? target : ".modal"
              //   )}
              menuPortalTarget={document.body} // Ensure the dropdown renders correctly within the modal
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              menuPlacement={dropView ? "top" : "bottom"}
            />
          )
        }}
      />
    </div>
  )
}

export default StateOnlyList
